import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";

export class UpdateCompanyReference {
  constructor(
    private readonly dispatcher: CommandDispatcher,
  ) { }

  async run(company_id,item,old_item): Promise<any> {
    let args = { 
        company_id: company_id,
        item: item,
        old_item: old_item
    }
    return await this.dispatcher.dispatch('update.company.reference', args)
  }
}